import type {
  InputHTMLAttributes,
  ReactNode,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from 'react';
import styles from './Field.module.css';

type FieldProps = {
  label: string;
  hint?: string;
  error?: string;
  compact?: boolean;
  children: ReactNode;
};

export function Field({ label, hint, error, compact, children }: FieldProps) {
  return (
    <div className={compact ? `${styles.field} ${styles.fieldCompact}` : styles.field}>
      <label className={styles.labelWrap}>
        <span className={styles.label}>{label}</span>
        {children}
      </label>
      {hint ? <div className={styles.hint}>{hint}</div> : null}
      {error ? (
        <div className={styles.error} role="alert">
          {error}
        </div>
      ) : null}
    </div>
  );
}

export function TextInput(props: InputHTMLAttributes<HTMLInputElement>) {
  return <input className={styles.input} {...props} />;
}

export function TextArea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const cn = className ? `${styles.textarea} ${className}` : styles.textarea;
  return <textarea className={cn} {...props} />;
}

export function SelectInput(props: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <div className={styles.selectWrap}>
      <select className={styles.select} {...props} />
      <span className={styles.selectChevron} aria-hidden>
        ▾
      </span>
    </div>
  );
}
